// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/base.scss
// module id = ./src/styles/base.scss
// module chunks = 0